<template>
    <b-navbar type="light" variant="success" v-if="!haveAnswered">
        <b-navbar-nav>
            <b-nav-text>{{ $t('text.cookie-consent') }}</b-nav-text>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
            <b-nav-form>
                <b-button-group size="sm" class="my-2 my-sm-0">
                    <b-button variant="success" @click="accept">{{ $t('text.accept') }}</b-button>
                </b-button-group>
            </b-nav-form>
        </b-navbar-nav>
        <b-button-close class="ml-4 mt-n4" @click="reject"></b-button-close>
    </b-navbar>
</template>
<script>
export default {
  name: 'CookieConsentBanner',
  data () {
    return {
      haveAnswered: !!localStorage.getItem('_cookie_consent_answered')
    }
  },
  methods: {
    accept () {
      localStorage.setItem('_cookie_consent_answered', 'yes')
      this.haveAnswered = true
      window._paq.push(['rememberConsentGiven'])
    },
    reject () {
      localStorage.setItem('_cookie_consent_answered', 'no')
      this.haveAnswered = true
    }
  }
}
</script>

<style lang="scss">

</style>